import Immutable from 'immutable';
import Predicate from 'sharedreact/data/Predicate';
import PublicParameter from 'sharedreact/data/PublicParameter';

const Content: {
  name: string,
  parameters: Immutable.List<PublicParameter>,
  visibleIfPredicate: Predicate | null,
  enabledIfPredicate: Predicate | null
} = {
  name: '',
  parameters: Immutable.List(),
  visibleIfPredicate: null,
  enabledIfPredicate: null
};

class PublicParameterGroup extends Immutable.Record(Content) {
}

export default PublicParameterGroup;
